module.exports = __webpack_public_path__ + "static/media/4.25c75fd6.png";